// Centralized transparency value for chart colors
export const CHART_COLOR_ALPHA = 0.7;

/**
 * Convert hex or rgba color to rgba with transparency
 * @param {string} color - Color in hex or rgba format
 * @param {number} alpha - Transparency value (0-1)
 * @returns {string} Color in rgba format with transparency
 */
export function colorToRgba(color, alpha = CHART_COLOR_ALPHA) {
  if (!color) return color;
  
  // If already rgba, return as is
  if (color.startsWith('rgba')) return color;
  
  // Handle hex colors
  let hex = color.replace('#', '');
  
  // Handle shorthand hex (e.g., #RGB)
  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('');
  }
  
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 * Apply transparency to dataset colors
 * @param {Array} datasets - Array of chart datasets
 * @returns {Array} Datasets with transparency applied
 */
export function applyTransparencyToDatasets(datasets) {
  return datasets?.map(dataset => ({
    ...dataset,
    backgroundColor: Array.isArray(dataset.backgroundColor)
      ? dataset.backgroundColor.map(color => color ? colorToRgba(color) : color)
      : dataset.backgroundColor ? colorToRgba(dataset.backgroundColor) : colorToRgba('#303F9F'),
    borderColor: Array.isArray(dataset.borderColor)
      ? dataset.borderColor.map(color => color ? colorToRgba(color) : color)
      : dataset.borderColor ? colorToRgba(dataset.borderColor) : colorToRgba('#303F9F'),
  })) || [];
}
